/**
 * Map an agent's job_roles[] (from the agent_role_assignment junction) to the
 * MSRP To-Path URI parameters.
 *
 * The `role` parameter is ALWAYS "agent" for backoffice dashboard agents.
 * Sending a different role value caused DB state-update issues server-side,
 * so the frontline/backoffice distinction is carried by a separate `subrole`
 * parameter instead.
 *
 * Managers / company admins can assign a job role to themselves, so the
 * To-Path follows whatever job role is assigned. With NO job role assigned,
 * the agent is treated as backoffice:
 *
 *   frontline (10)                                  → role=agent (no subrole)
 *   backoffice (11) / management (12) / other (13)  → role=agent;subrole=backoffice
 *   no job role assigned                            → role=agent;subrole=backoffice
 *
 * Accepts either number[] (e.g. [10]) or the joined object form
 * (e.g. [{ role: 10 }]).
 */
const FRONTLINE = 10;

const firstRoleNum = (jobRoles) => {
  if (!Array.isArray(jobRoles) || jobRoles.length === 0) return null;
  const first = jobRoles[0];
  return typeof first === "object" && first !== null ? first.role : first;
};

/**
 * The MSRP `role` URI parameter. Always "agent" regardless of job role.
 */
export const mapJobRoleToMsrpRole = () => "agent";

/**
 * The MSRP `subrole` URI parameter.
 *
 *   frontline (10)        → "" (subrole is omitted from the URI)
 *   any other job role    → "backoffice"
 *   no job role assigned  → "backoffice"
 *
 * @param {number[]|{role:number}[]} jobRoles  agent_role_assignment job roles
 */
export const mapJobRoleToMsrpSubrole = (jobRoles) => {
  const roleNum = firstRoleNum(jobRoles);
  if (roleNum === FRONTLINE) return "";
  return "backoffice";
};
